/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useEffect, useRef, useState } from 'react';

interface PdfPageCanvasProps {
  file: File;
  pageNumber: number; // 1-based
  scale?: number;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export function PdfPageCanvas({
  file,
  pageNumber,
  scale = 0.3,
  onClick,
  style,
}: PdfPageCanvasProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function render() {
      try {
        const pdfjsLib = await import('pdfjs-dist');
        pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

        const buffer = await file.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;
        const page = await pdf.getPage(pageNumber);

        if (cancelled) return;

        const viewport = page.getViewport({ scale });
        const canvas = canvasRef.current;
        if (!canvas) return;

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({
          canvasContext: canvas.getContext('2d')!,
          viewport,
        }).promise;
      } catch {
        if (!cancelled) setError(true);
      }
    }

    render();
    return () => {
      cancelled = true;
    };
  }, [file, pageNumber, scale]);

  if (error) {
    return (
      <div
        style={{
          width: 120,
          height: 170,
          background: '#f1f3f5',
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 11,
          color: '#adb5bd',
          ...style,
        }}
      >
        Erro
      </div>
    );
  }

  return (
    <canvas
      ref={canvasRef}
      onClick={onClick}
      style={{
        borderRadius: 4,
        cursor: onClick ? 'pointer' : 'default',
        display: 'block',
        ...style,
      }}
    />
  );
}
